// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1-qHs","footer":"ModalFilter_footer__37LZB"};